import { Theme } from '@mui/material';

export const cardStyles = (theme: Theme) => ({
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: '6px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: 'none',
        width: '100%',
        '&.MuiPaper-root': {
          backgroundColor: theme.palette.background.default,
        },
      },
    },
  },
});
